// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"7da4e29e","833":"998bf64d"}[chunkId] + ".chunk.js";
};